import * as uuid from "uuid";

export interface CorrelationId {
  currentId: string;
  parentId: string;
  operationId: string;
}
interface ProtoCorrelationId {
  correlationOperationId: string;
  correlationParentId: string;
  correlationCurrentId: string;
}

const COMPONENT_NAME = "KnoP";
export const CorrelationId = {
  create: (): CorrelationId => {
    const currentId = `${COMPONENT_NAME}:${createBase64Uuid()}`;
    return {
      currentId,
      parentId: currentId,
      operationId: `${COMPONENT_NAME}:${createBase64Uuid()}`,
    };
  },
  createChild: (parent: CorrelationId): CorrelationId => ({
    operationId: parent.operationId,
    parentId: parent.currentId,
    currentId: `${COMPONENT_NAME}:${createBase64Uuid()}`,
  }),
  toHeaders: (correlationId: CorrelationId) => ({
    "X-Correlation-CurrentId": correlationId.currentId,
    "X-Correlation-ParentId": correlationId.parentId,
    "X-Correlation-OperationId": correlationId.operationId,
  }),
  fromProto: (protoCorrelationId: ProtoCorrelationId): CorrelationId => ({
    operationId: protoCorrelationId.correlationOperationId,
    parentId: protoCorrelationId.correlationParentId,
    currentId: protoCorrelationId.correlationCurrentId,
  }),
};

function createBase64Uuid(): string {
  const uuidAsBytes = uuid.parse(uuid.v4());
  return uuidAsBytes.toBase64();
}
